import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "stop",
  "use": "stop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"stop\"><path d=\"M128 128a128 128 0 1 1 256 0v768a128 128 0 0 1-256 0V128zm512 0a128 128 0 0 1 256 0v768a128 128 0 0 1-256 0V128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol